/**
 * Subscription form submission and animation handler
 * Handles form submission and animates the subscription form
 * to show a donation call-to-action after successful subscription.
 *
 * This is a separate webpack entry point that only loads on pages
 * that include the subscription form component.
 */

/* eslint-env browser, es6 */

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const postSubscribeHeading = "Thanks for subscribing!";
const postSubscribeSubtitle =
  "Donate to support our fight for abundant, affordable homes for all!";

async function animateSubscribeSuccess() {
  const block = document.getElementById("subscribe-block");
  const title = document.getElementById("subscribe-title");
  const subtitle = document.getElementById("subscribe-subtitle");
  const form = document.getElementById("subscribe-form");
  const donate = document.getElementById("subscribe-donate");

  if (block) {
    block.style.height = block.offsetHeight + "px";
  }

  const staggerTime = 100; // Time between each element
  const animationDuration = 500;

  if (block && title && subtitle && form && donate) {
    // Fade out
    title.classList.add("opacity-0", "-translate-y-2");
    donate.style.display = "block";
    await sleep(staggerTime);
    subtitle.classList.add("opacity-0", "-translate-y-2");
    await sleep(staggerTime);

    form.remove();
    await sleep(animationDuration);

    // Change content
    block.classList.remove(
      "bg-gradient-to-t",
      "from-lime-300",
      "to-sky",
      "bg-lime-300"
    );
    block.classList.add("bg-[#A7F3D0]");

    title.textContent = postSubscribeHeading;
    subtitle.textContent = postSubscribeSubtitle;

    title.classList.remove("-translate-y-2");
    subtitle.classList.remove("-translate-y-2");

    // Prepare fade in
    title.classList.add("opacity-0", "translate-y-2");
    subtitle.classList.add("opacity-0", "translate-y-2");
    await sleep(50);

    block.style.height = null;

    // Fade in
    title.classList.remove("opacity-0", "translate-y-2");
    await sleep(staggerTime);
    subtitle.classList.remove("opacity-0", "translate-y-2");
    await sleep(staggerTime);

    donate.classList.remove("opacity-0", "translate-y-2");
  } else if (block) {
    block.style.height = null;
  }
}

/**
 * Handles form submission via AJAX and triggers success animation
 * @param {string} webhookUrl - The URL to submit the form to
 * @param {HTMLElement} element - The form element
 * @param {string} _successText - Success message (currently unused but kept for compatibility)
 * @returns {boolean} Always returns false to prevent default form submission
 */
// eslint-disable-next-line no-unused-vars
window.formSubmit = async function (webhookUrl, element, _successText) {
  const formData = new FormData(element);
  const request = new XMLHttpRequest();
  request.open("POST", webhookUrl);

  try {
    request.send(formData);
    try {
      await animateSubscribeSuccess();
    } catch (animationError) {
      console.error("Animation error:", animationError);
    }
  } catch (e) {
    element.innerHTML =
      "<div><span class='text-4xl font-bold tracking-tight block italic'>Something went wrong.</span></div>";
  }

  return false;
};

/**
 * Prevents Enter key from submitting forms unless they have the 'allow-enter-submit' class
 */
function preventEnterKeySubmit() {
  const forms = document.getElementsByTagName("form");
  for (let i = 0; i < forms.length; i++) {
    forms[i].onkeydown = function (e) {
      // Allow forms with the 'allow-enter-submit' class to use 'Enter'
      if (this.classList.contains("allow-enter-submit")) {
        return true;
      }

      const key = e.charCode || e.keyCode || 0;
      if (key === 13) {
        e.preventDefault();
      }
    };
  }
}

// Initialize on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", preventEnterKeySubmit);
} else {
  preventEnterKeySubmit();
}
